export const NOTIFICATION_DELAY_MS = 500

export const DISPATCHER_NOTIFICATION_TYPES = {
    ORDER_UPDATED: 'order_updated',
    PRINT_STATUS: 'print_status',
    PRINT_GROUP_STATUS: 'print_group_status',
    ROUTE_UPDATED: 'route_updated',
    ROUTE_DELETED: 'route_deleted',
}
